/**
 * Represents the different abilities a user can have.
 * @description Abilities are distinct from permissions. While permissions help
 * answer a single question, abilities can answer multiple. For example,
 * 'read-only' is a combination of two permission checks - that you CAN read,
 * and you CANNOT write. Hence, we model it as a read-only ability.
 */
export enum Ability {
  /**
   * Ability to view content.
   */
  read = 'read',

  /**
   * Ability to edit content.
   */
  write = 'write',

  /**
   * Ability to only view content - not edit it.
   */
  readOnly = 'read-only',

  /**
   * Ability to add comments to elements.
   */
  addComment = 'add-comment',

  /**
   * Ability to delete comments.
   */
  deleteComment = 'delete-comment',
}
